enum FetchState {
  // Initial data load, we still don't have anything to show
  IN_PROGRESS,
  // Data reload, we have old data but we are updating it
  RELOADING,
  // No request in progress, last request was successful
  SUCCESS,
  // No request in progress, last request resulted in an error
  ERROR,
}

export default FetchState;
